package com.anjuros.website.templates.template9.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template9.modules.Template9Section
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColor
import com.anjuros.website.templates.template9.styles.Template9ColorVar
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9NavigationItemStyle
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9CompanyDetails
import com.anjuros.website.templates.template9.util.Template9Constants
import com.anjuros.website.templates.template9.util.Template9Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template9Header(onMenuClicked: () -> Unit) {

    Row(
        modifier = Template9ContainerStyle.toModifier()
            .padding(topBottom = 22.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {

        Row(
            modifier = Modifier.gap(12.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            MenuIcon(
                modifier = Modifier
                    .displayUntil(Breakpoint.LG)
                    .cursor(Cursor.Pointer)
                    .color(Template9Theme.Primary.getColor())
                    .onClick { onMenuClicked() }
            )
            Template9Logo()
        }

        Template9NavigationRow(
            modifier = Modifier.displayIfAtLeast(Breakpoint.LG)
        )

        Template9PrimaryButton(
            modifier = Modifier.displayIfAtLeast(Breakpoint.MD),
            text = ResKey.TEMPLATE9_BUTTON_BOOK,
            path = Template9Section.Contact.path,
            small = true
        )
    }
}

/** Paw logo + company name + small subtitle. Used in the header, menu and footer. */
@Composable
fun Template9Logo(
    nameColor: CSSColorValue = Template9Theme.Secondary.rgb,
    subtitleColor: CSSColorValue = Template9Theme.Primary.getColor()
) {
    Link(
        modifier = Modifier.textDecorationLine(TextDecorationLine.None),
        path = Template9Section.Home.path
    ) {
        Row(
            modifier = Modifier.gap(10.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            AnjurosLogo(
                modifier = Modifier
                    .size(44.px)
                    .maxWidth(52.px)
                    .maxHeight(52.px)
                    .objectFit(ObjectFit.Contain),
                src = Template9Res.Icon.logo,
                alt = "Dog walker website logo"
            )
            Column {
                P(
                    attrs = Modifier
                        .margin(0.px)
                        .fontFamily(Template9Constants.HEADING_FONT_FAMILY, Template9Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Bold)
                        .fontSize(22.px)
                        .lineHeight(1.1)
                        .color(nameColor)
                        .toAttrs()
                ) {
                    AnjurosText(Template9CompanyDetails.CLIENTS_COMPANY_INFO)
                }
                P(
                    attrs = Modifier
                        .margin(0.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontWeight(FontWeight.Bold)
                        .fontSize(9.px)
                        .letterSpacing(2.px)
                        .color(subtitleColor)
                        .toAttrs()
                ) {
                    Text(LocalText(ResKey.TEMPLATE9_LOGO_SUBTITLE))
                }
            }
        }
    }
}

@Composable
fun Template9NavigationRow(modifier: Modifier = Modifier) {
    val color = Template9Theme.Primary.getColor()
    Row(
        modifier = modifier.gap(36.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Template9Section.entries.forEach { section ->
            Link(
                modifier = Modifier.textDecorationLine(TextDecorationLine.None),
                path = section.path
            ) {
                P(
                    attrs = Template9NavigationItemStyle.toModifier()
                        .setVariable(Template9ColorVar, color)
                        .margin(0.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.Medium)
                        .toAttrs()
                ) {
                    Text(LocalText(section.title))
                }
            }
        }
    }
}
